import { createFileRoute } from "@tanstack/react-router"
import { LoadingScreen } from "@/ui/components"

export const Route = createFileRoute("/(user)/(tenant)/dashboard")({
  component: RouteComponent,
})

function RouteComponent() {
  return <LoadingScreen />
}
